<template>
  <div class="app">
    <div class="app-content">
      <div
        class="box"
        :style="{
        'width': `${width}px`,
        'height': `${height}px`,
        transform: `scale(${scalseNum})`,
        '-webkit-transform': `scale(${scalseNum})`,
        '-moz-transform': `scale(${scalseNum})`,
        '-o-transform': `scale(${scalseNum})`,
        '-ms-transform': `scale(${scalseNum})`,
      }"
      >
        <!-- <h1>缩放的盒子 比例是：X:{{ scalseWidth }},Y:{{scalseHeight}}</h1> -->
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ScaleBox",
  props: {
    width: {
      type: Number,
      default: () => 1920
    },
    height: {
      type: Number,
      default: () => 1080
    }
  },
  data() {
    return {
      scalseNum: 1, // 缩放比例
      scalseHeight: 1,
      scalseWidth: 1
    };
  },
  mounted() {
    // 计算缩放比例
    this.$nextTick(() => {
      this.resize_window();
    });
    window.addEventListener("resize", () => {
      console.log("resize");
      this.resize_window();
    });
  },
  methods: {
    // 计算缩放比例
    resize_window() {
      const w_height = Number(
        document.documentElement.clientHeight / this.height
      );
      const w_width = Number(document.documentElement.clientWidth / this.width);

      let scalseNum = 1;
      w_width > w_height ? (scalseNum = w_height) : (scalseNum = w_width);

      this.scalseNum = scalseNum;
    }
  }
};
</script>

<style lang="less" scoped>
.app {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000810;
  display: -ms-flexbox;
  -ms-justify-content: center;
  -ms-align-items: center;
  flex-direction: column;
}

.app-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.box {
  // width: 1080px;
  // height: 1920px;
  flex-shrink: 0;
  flex-grow: 0;
}
</style>
